import styled from '@emotion/styled';

export const ListingArea = styled.div`
	> div > div > div {
		padding: unset;
	}
`;
